import { IAction } from "@faire/web-api/indigofair/data/IAction";

type LinkAndActions = {
  link: string | undefined;
  nonNavigationActions: IAction[];
};

export function extractLinkFromActions(actions: IAction[]): LinkAndActions {
  return {
    link: actions.find((action) => action.navigate)?.navigate?.link,
    nonNavigationActions: actions.filter((action) => !action.navigate),
  };
}
